import React, { useState } from "react";
import { Box, Typography, Button, Modal, Alert } from "@mui/material";
import { useAuth } from "../../context/auth";
import { useNavigate } from "react-router-dom";

const DeleteModal = ({ open, setOpen }) => {
  // const handleTournamentDelete = () => {};
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal" style={{ padding: "20px" }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <Alert severity="warning" sx={{ fontSize: "16px" }}>
              Are you sure . You want to log out.
            </Alert>
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpen(false)}
              style={{ fontSize: "14px" }}
            >
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
                logout(true);
                navigate(`/admin/authenticate`);
              }}
              style={{ fontSize: "14px" }}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteModal;
